const riotBarLevel = 10000;
export const zIndex = {
  modalLevel: riotBarLevel + 2,
  topLevel: riotBarLevel + 1,
  midLevel: 1,
  groundLevel: 0,
  auto: "auto",
  negativeLevel: -1,
};

// named sizes for screen widths.
export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  mobileXL: "600px",
  tablet: "768px",
  laptop: "1024px",
  laptopM: "1280px",
  laptopL: "1440px",
  laptopXL: "1560px",
  desktop: "1920px",
  desktopL: "2560px",
};

// Named devices for media queries.
export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  mobileXL: `(min-width: ${size.mobileXL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopM: `(min-width: ${size.laptopM})`,
  laptopL: `(min-width: ${size.laptopL})`,
  laptopXL: `(min-width: ${size.laptopXL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktopL})`,
};
